import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationService } from '../../../core/services/application.service';


@Component({
  selector: 'pegasus-discount-notification',
  standalone: true,
  imports: [],
  templateUrl: './discount-notification.component.html',
  styleUrl: './discount-notification.component.scss'
})

export class DiscountNotificationComponent {
  private modal = inject(NgbActiveModal);

  @Input() notificationTitle: string = 'Notification';
  @Input() notificationBody: string = 'You have a new notification';

  constructor(
    public activeModal: NgbActiveModal,
    private appService: ApplicationService
  ) {}

  async acknowledge() {
    try {
      this.activeModal.close(); // Close modal after sync
      await this.appService.syncData(); // ✅ Calls your sync logic
      console.log('Acknowledged');
    } catch (error) {
      console.error('Sync failed', error);
    }
  }
}
